<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Institucijos') }}</h1>
    <!-- add button  -->
    <el-button
      class="mb-5"
      color="primary"
      icon="pridėti"
      title="Pridėti naują"
      :loading="loading"
      @click.native.stop="newItem()"
    />
    <!-- search -->
    <admin-institutions-search
      :loading="loading"
      @search="searchInstitutions"
    />
    <!-- table -->

    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.institution_groups`]="{ item }">
        <el-table-array-item :items="item.institution_groups" />
      </template>
      <!--main custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @editItem="editItem(item)"
            @viewItem="editItem(item)"
            @deleteItem="deleteItem(item)"
            @restoreItem="restoreItem(item)"
          />
        </div>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
     <modal-delete
      title="Šalinti įrašą"
      text="Ar tikrai norite pašalinti įrašą?"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import AdminInstitutionsSearch from './AdminInstitutionsSearch'
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'

export default {
  name: 'Institutions',
  components: {
    AdminInstitutionsSearch,
    ModalDelete,
  },
  mixins: [userRole],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      listData: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Juridinio asmens kodas'),
          align: 'start',
          value: 'code',
        },
        {
          text: this.$t('Institucijos pavadinimas (LT)'),
          align: 'start',
          value: 'title_lt',
        },
        {
          text: this.$t('Institucijos pavadinimas (EN)'),
          align: 'start',
          value: 'title_en',
        },
        {
          text: this.$t('Institucijos grupės'),
          align: 'start',
          value: 'institution_groups',
        },
        {
          text: this.$t('Galioja nuo'),
          align: 'start',
          value: 'valid_from',
          width: "8rem"
        },
        {
          text: this.$t('Galioja iki'),
          align: 'start',
          value: 'valid_to',
          width: "7rem"
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {

  },
  created() {},
  methods: {
    newItem() {
      this.$router.push({
        name: 'adminInstitutionForm',
      })
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`institutions/list`, data)
        .then((res) => {
          this.listData = res.data.institutions
          this.pagination = { ...this.pagination, ...res.data.pagination }

        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchInstitutions(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(true)
    },

    editItem(item, mode) {
      this.$router.push({
        name: 'adminInstitutionForm',
        params: {
          id: item.id,
        },
      })
    },

    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },

    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`institutions/${item.id}`)
        .then((res) => {
          this.$root.$emit('DATA_OK_CODE', '000111')
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.showDelete = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
